import { render, staticRenderFns } from "./sidebarcommunity.vue?vue&type=template&id=56788a58"
import script from "./sidebarcommunity.vue?vue&type=script&lang=js"
export * from "./sidebarcommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports